export function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function breakpointRange(name) {
  const value = getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${name}`)
  return value ? window.matchMedia(`(width >= ${value.trim()})`) : null
}
